<wiz-hgroup
width="100%"
height="100%"
verticalAlign="center"
[style.backgroundColor]="backgroundColor"
[style.color]="fontColor"
style="padding-left: 5px; padding-right: 5px;">
<wiz-icon *ngIf="hasChildren" style="cursor: pointer;" (click)="expandOrCollapse()"
[style.backgroundColor]="backgroundColor"
[style.color]="fontColor">{{arrowKind()}}</wiz-icon>
<wiz-hgroup width="100%" height="100%" verticalAlign="center"> <!--*ngIf="showLabel"-->
  <wiz-vgroup  width="100%" height="100%" verticalAlign="center" gap="-3">
    <wiz-label #lbl wizTextBehavior="wordWrap" 
    [style.textAlign]="textAlign"
    [wizLabel]="displayName" [tooltipText]="displayName"
    [wizNbLine]="3"
    width="100%"></wiz-label>

    <wiz-label *ngIf="!!subLabel" wizTextBehavior="truncate" class="smallFont"
        [style.textAlign]="textAlign"
        [wizLabel]="subLabel" [tooltipText]="subLabel"
        width="100%"></wiz-label>

  </wiz-vgroup>

</wiz-hgroup>
<wiz-image *ngIf="isBinary" width="24px" height="24px" [sourceObservable]="binSource"></wiz-image><!-- && showLabel-->
</wiz-hgroup>